import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-drawer-layout',
  templateUrl: './modal-drawer-layout.component.html',
  styleUrls: ['./modal-drawer-layout.component.scss']
})
export class ModalDrawerLayoutComponent {
  // if the Footer is present or not
  @Input() isFooterPresent = true;

  // To specify if the close icon should be customized.
  @Input() customizeCloseIcon = false;

  // To emit an event when close button is clicked,
  // when the close button function is customizable.
  @Output() closeIconClick: EventEmitter<void> = new EventEmitter();

  /**
   * This function is called when the close icon is clicked.
   * But only when the close icon functionality is customizable
   * i.e customizeCloseIcon is true.
   */
  onCloseIconClick = () => this.closeIconClick.emit();
}
